var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-button",
        {
          staticClass: "md-success",
          attrs: { title: "Add new charge" },
          on: { click: _vm.showCreateNewLineDialog },
        },
        [_vm._v("\n        Add new " + _vm._s(_vm.title) + "\n    ")]
      ),
      _c(
        "md-dialog",
        {
          staticClass: "create-mobile-container",
          attrs: { "md-active": _vm.showDialog },
          on: {
            "update:mdActive": function ($event) {
              _vm.showDialog = $event
            },
            "update:md-active": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _c("md-dialog-title", [_vm._v("Add New " + _vm._s(_vm.title))]),
          _c("md-dialog-content", [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.createLine($event)
                  },
                },
              },
              [
                _c("div", { staticClass: "md-layout" }, [
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Description")]),
                          _c("md-input", {
                            attrs: { required: "", maxlength: "100" },
                            model: {
                              value: _vm.lineForm.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.lineForm, "description", $$v)
                              },
                              expression: "lineForm.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        " md-layout-item md-size-100date-inputs-container",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "date-input-wrapper" },
                        [
                          _c(
                            "md-field",
                            { staticClass: "date-field" },
                            [
                              _c("md-datepicker", {
                                attrs: { required: "", "md-immediately": "" },
                                model: {
                                  value: _vm.lineForm.tripDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.lineForm, "tripDate", $$v)
                                  },
                                  expression: "lineForm.tripDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Amount")]),
                          _c("md-input", {
                            attrs: {
                              required: "",
                              maxlength: "10",
                              type: "number",
                            },
                            model: {
                              value: _vm.lineForm.unitPriceExTax,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.lineForm,
                                  "unitPriceExTax",
                                  _vm._n($$v)
                                )
                              },
                              expression: "lineForm.unitPriceExTax",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "md-layout-item md-size-100" },
                    [
                      _c(
                        "md-field",
                        [
                          _c("label", [_vm._v("Account Code")]),
                          _c("md-input", {
                            attrs: { maxlength: "15" },
                            model: {
                              value: _vm.lineForm.accountCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.lineForm, "accountCode", $$v)
                              },
                              expression: "lineForm.accountCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _c(
            "md-dialog-actions",
            { staticClass: "actions-custom" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-default",
                  on: {
                    click: function ($event) {
                      _vm.showDialog = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  attrs: { disabled: !_vm.isFormValid },
                  on: { click: _vm.createLine },
                },
                [_vm._v("Create")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }